import { ActivateCardState } from './activateCard.types';

export const CARD_NUMBER_LENGTH = 16;
export const CARD_MAX_LENGTH = 19;

export const SUPPORTED_CARD_BINS: string[] = ['511925'];
export const STEP_DATA = 1;
export const STEP_LIMIT = 2;
/** Resumen de confirmación previo a la activación (tarjeta, asignado y límite). */
export const STEP_CONFIRM = 3;
export const STEP_CONFIRMATION = 4;
export const STEP_FAILED = 5;

export const getInitialState = (userName: string, email: string = ''): ActivateCardState => ({
    step: STEP_DATA,
    fullName: userName,
    email,
    cardNumber: '',
    confirmCardNumber: '',
    spendingLimit: '',
    spendingLimitDisplay: '',
    isEditingLimit: false,
    maxAvailableLimit: 0,
    isPendingApproval: false,
    isLoading: false,
    errorCount: 0,
    errors: {},
});


